module.exports = __webpack_public_path__ + "static/img/307_TO8_2292.a453640.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/307_TO8_2292.jpg
// module id = eG59
// module chunks = 0